<app-base-modal
  [title]="'Показать/Скрыть колонки'"
>
  <div class="settings-container">
    <div class="settings-profile-row">
      <mat-form-field
        appearance="outline"
        class="settings-profile-field"
      >
        <mat-label>Профиль</mat-label>
        <mat-select
          [(ngModel)]="selectedProfile"
          (selectionChange)="handleChangeProfile()"
        >
          <mat-select-trigger>
            {{ selectedProfile }}
          </mat-select-trigger>
          <mat-option value="all">Без профиля</mat-option>
          @for (option of columnProfiles; track $index) {
            <mat-option [value]="option">
              <span class="settings-profile-name">{{ option }}</span>
              <div class="settings-profile-btns">
                <button
                  mat-mini-fab
                  class="settings-profile-btn"
                  (click)="handleEditProfile($event, option)"
                >
                  <mat-icon class="settings-profile-icon">edit</mat-icon>
                </button>
                <button
                  mat-mini-fab
                  class="settings-profile-btn"
                  (click)="handleDeleteProfile($event, option)"
                >
                  <mat-icon class="settings-profile-icon">delete</mat-icon>
                </button>
              </div>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button
        mat-icon-button
        class="btn-add"
        (click)="handleAddProfile()"
      >
        <mat-icon class="btn-add-icon">add</mat-icon>
      </button>
    </div>
    @if (selectedProfile) {
      <mat-form-field
        appearance="outline"
        class="mat-form-field"
      >
        <mat-label>Колонки</mat-label>
        <mat-select
          multiple
          [(ngModel)]="selectedColumns"
        >
          <mat-checkbox
            [checked]="isAllSelected()"
            (change)="toggleSelectAll()"
          >
            {{ isAllSelected() ? 'Снять все' : 'Выбрать все' }}
          </mat-checkbox>
          <mat-divider></mat-divider>
          @for (option of recordTableColumnParams; track $index) {
            <mat-option
              [value]="option"
              [disabled]="option.sticky || false"
            >
              {{ option.name }}
              @if (option.sticky) {
                <span>(закреплена)</span>
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      (click)="handleSaveSettings()"
    >
      Сохранить
    </button>
    <button
      mat-button
      tabindex="-1"
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
